import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, catchError, combineAll } from 'rxjs/operators';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';

export const loadMetaEpic: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi, storeApi, collectionApi },
) =>
  action$.pipe(
    ofType(actions.META_ACTIONS.REQUESTED),
    switchMap(() =>
      of(
        regionApi.getCities(),
        storeApi.getFactories(),
        storeApi.getMarkets(),
        regionApi.getCountries(),
        regionApi.getRegions(),
        collectionApi.getCollections(),
      ).pipe(
        combineAll(),
        switchMap(info => {
          const meta = info.reduce(
            (result, item) => ({
              ...result,
              ...item,
            }),
            {},
          );
          return of(actions.metaSucceeded(meta));
        }),
        catchError(({ response: { error } }) => of(actions.metaFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/store/meta/epics/loadMeta.ts